import cx from 'classnames';

import { IconDone } from '../../../../design-system/components/icons/Done';

import style from './ProposalList.module.css';

type item = {
    text: string;
};

type Props = {
    list: item[];
};

export function ProposalList({ list }: Props) {
    return (
        <ul className={style.groupsProposalList}>
            {list.map((item) => (
                <li key={item.text} className={cx(style.proposal, 'font-xs-regular')}>
                    <IconDone className={style.icon} />
                    {item.text}
                </li>
            ))}
        </ul>
    );
}
